export default "__VITE_ASSET__CIfftKvd__"